import {Dispatch, SetStateAction} from 'react';
import SpinnerLoading from '../../../../../../components/SpinnerLoading';
import {IGetAccountNumbersResponse} from '../../../../../../services/hookService/getAccountNumbers/getAccountNumbers';

interface IProps {
  accountNumbersData?: IGetAccountNumbersResponse;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isLoading?: boolean;
  hasAccount: boolean;
}

const AccountFillSection = ({
  accountNumbersData,
  setOpen,
  isLoading = false,
  hasAccount,
}: IProps) => {
  if (isLoading) return <SpinnerLoading size={25} />;

  return (
    <div className="my-4 rounded-lg bg-[#FAFDF7] text-neutral-600">
      <div className="flex flex-col gap-3 p-3">
        <span className="self-start text-sm font-normal text-right text-farm-shop-600">
          {hasAccount ? (
            <div className="flex gap-3">
              <span>شماره حساب شما</span>
              <span>{accountNumbersData?.bank_account_number}</span>
            </div>
          ) : (
            'شماره حسابتان را جهت واریز وجه وارد کنید.'
          )}
        </span>

        <button
          onClick={() => setOpen(true)}
          className="self-end px-3 py-1 text-sm text-white rounded-lg bg-lime-700"
        >
          {hasAccount ? 'تغییر شماره حساب' : 'افزودن شماره حساب'}
        </button>
      </div>
    </div>
  );
};

export default AccountFillSection;
